 ;
 import React from "react";
 import {
   View,
   Text,
   TouchableOpacity,
   StyleSheet,
 } from "react-native";
 import { Ionicons } from "@expo/vector-icons";
 import { useNavigation } from "@react-navigation/native";
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard";
 
 interface Props {
   onPress?: () => void;
 }
 
 const HeaderWithBack = ({ onPress }: Props) => {
   const navigation = useNavigation();
 
   const handleBack = () => {
     if (onPress) {
       onPress();
     } else {
       navigation.goBack();
     }
   };
 
   return (
     <View style={styles.wrapper}>
       <TouchableOpacity
         style={styles.button}
         activeOpacity={0.8}
         onPress={handleBack}
       >
         <Ionicons name="arrow-back" size={20} color={COLORS.primary} />
         <Text style={styles.text}>GO BACK</Text>
       </TouchableOpacity>
     </View>
   );
 };
 
 export default HeaderWithBack;
 
 const styles = StyleSheet.create({
   wrapper: {
     alignItems: "flex-start",
     marginTop:20
   },
 
   button: {
     flexDirection: "row",
     alignItems: "center",
     paddingVertical: 6,
     paddingHorizontal:10,
     borderRadius: 8,
     borderWidth: 2,
     borderColor: "#C4B5FD",
     backgroundColor: "#F9FAFB",
   },
 
   text: {
     marginLeft: 12,
     fontSize: 16,
     fontWeight: "600",
     letterSpacing: 1,
     color:COLORS.primary,
   },
 });
 